import {ChangeDetectionStrategy, Component, Injector, OnInit, ViewChild} from '@angular/core';
import {Log, LogTag} from '../services/Log';
import {concatMap, filter, Observable, of, tap} from "rxjs";
import {lastMap} from "../rxjs/lastMap";
import {PlayerPwaService} from "../services/PlayerService/player.pwa.service";
import {PlayerBaseService} from "../services/PlayerService/player.base.service";
import {SignagePlayerBase} from "./signage.player.base";
import {delay} from "rxjs/operators";

@Component({
    selector: 'signage-player-pwa',
    templateUrl: './signage.player.pwa.html',
    styleUrls: ['./signage.player.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignagePlayerPwa extends SignagePlayerBase implements OnInit {
  state = '';

  constructor(protected injector: Injector) {
    super(injector);
  }


  @ViewChild('checkInstalledPage', {static: false}) checkInstalledPage;
  @ViewChild('installPage', {static: false}) installPage;
  @ViewChild('closePage', {static: false}) closePage;
  @ViewChild('checkInternetPage', {static: false}) checkInternetPage;
  @ViewChild('hostPage', {static: false}) hostPage;
  @ViewChild('loginPage', {static: false}) loginPage;
  @ViewChild('registrationPage', {static: false}) registrationPage;


  init(): Observable<any> {
    const logInfo = Log.getLogInfo("SignagePlayerPwa", "init", []);
    Log.d(logInfo, LogTag.SIGNAGE_PLAYER, '');
    return super.init().pipe(
      concatMap(r => {
        if ((<PlayerPwaService>this.playerService).runningAsApp()) {

          /***************************************************/
          //  TESTS  FOR SEAN !!!!
          // this.state = 'checkInstalled';
          // this.state = 'close';
          // this.state = 'install';
          // this.state = 'login';
          //  this.state = 'registration';
          /*****************************************************/
          // this.state = 'install';
          return of('next');

        } else { // running in browser
          Log.d(logInfo, LogTag.SIGNAGE_PLAYER, 'checkInstalled...');
          this.state = 'checkInstalled';
          this.changeDetectorRef.detectChanges();
          return this.checkInstalledPage.readyToInstall().pipe(
            concatMap(installed => {
              Log.d(logInfo, LogTag.SIGNAGE_PLAYER, 'installed=' + installed);
              if (installed) {
                Log.d(logInfo, LogTag.SIGNAGE_PLAYER, 'start close()');
                this.state = 'close';
                this.changeDetectorRef.detectChanges();
                return this.closePage.close();
              } else {
                Log.d(logInfo, LogTag.SIGNAGE_PLAYER, 'start install');
                this.state = 'install';
                this.changeDetectorRef.detectChanges();
                return this.installPage.install();
              }
            })
          )
        }
      }),
      filter(a => (a != null)),
      concatMap(v => {
        if ((this.playerService as PlayerBaseService).domain === null) {
          this.state = "checkInternet";
          this.changeDetectorRef.detectChanges();
          return this.checkInternetPage.isConnected().pipe(
            lastMap(connected => {
              (<PlayerBaseService>this.playerService).domain = "galaxy.signage.me";
              this.state = 'host';
              this.changeDetectorRef.detectChanges();
              return this.hostPage.getHost()
            }),
            lastMap(data => {
              Log.d(logInfo, LogTag.SIGNAGE_PLAYER, 'switch login');
              this.state = 'login';
              this.changeDetectorRef.detectChanges();
              return this.loginPage.login();
            }),
            lastMap(r => {
              Log.d(logInfo, LogTag.SIGNAGE_PLAYER, 'switch registration');
              if ((this.playerService as PlayerPwaService).sceneId==null) {
                this.state = 'registration';
                this.changeDetectorRef.detectChanges();
                return this.registrationPage.register();
              } else {
                if (localStorage['deployment'] != null) {
                  const deployment = JSON.parse(localStorage['deployment']);
                  deployment.prompt = false;
                  localStorage['deployment'] = JSON.stringify(deployment);
                }
                return of('signage');
              }
            })
          )
        } else {
          return of('signage');
        }
      }),
      lastMap(r => {
        Log.d(logInfo, LogTag.SIGNAGE_PLAYER, 'switch signage');
        this.state = 'signage';
        this.changeDetectorRef.detectChanges();
        (this.playerService as PlayerBaseService).playerChannel$.next({cmd: 'status', param: 'signage'});
        (this.playerService as PlayerBaseService).startServerSocket();
        return of('completed')
      })
    )
  }

  mainSceneLoaded() {
    let key = null;
    let kiosk = false;
    if (this.mainScene?.playerObject?.Metadata!=null && this.mainScene.playerObject.Metadata[0].Kiosk!=null) {
      if (this.mainScene.playerObject.Metadata[0].Kiosk[0].$.mode == "1") {
        kiosk = true;
        key = this.mainScene.playerObject.Metadata[0].Kiosk[0].$.key;
      }
    }
    (this.playerService as PlayerBaseService).playerChannel$.next({cmd: 'kiosk', enabled: kiosk, key: key});
  }

  dispose(): void {
    super.dispose();
  }
}
